import React from 'react';
import './Book3D.css';

interface Book3DProps {
    cover: string;
    title: string;
    /** Printed on the spine ahead of the title, as a real one would be. */
    author?: string;
    className?: string;
}

/**
 * A book as a box: front cover, spine, fore edge, head, back. Its angle is
 * whatever `--book-rot` happens to be, so the shelf can drive it from a
 * hover rule and the library can drive it from scroll position without the
 * object itself knowing the difference.
 */
const Book3D: React.FC<Book3DProps> = ({ cover, title, author, className }) => (
    <div className={`book3d ${className || ''}`.trim()} aria-hidden="true">
        <div className="book3d__body">
            <div
                className="book3d__face book3d__front"
                style={{ backgroundImage: `url(${cover})` }}
            />
            {/* The spine reuses the cover as its own background, anchored to
                the cover's left edge and darkened, so each book gets a spine
                colour that belongs to it without anyone having to pick one
                by hand. */}
            <div
                className="book3d__face book3d__spine"
                style={{ backgroundImage: `url(${cover})` }}
            >
                {author && <span className="book3d__spine-author">{author}</span>}
                <span className="book3d__spine-title">{title}</span>
            </div>
            <div className="book3d__face book3d__pages" />
            <div className="book3d__face book3d__top" />
            <div
                className="book3d__face book3d__back"
                style={{ backgroundImage: `url(${cover})` }}
            />
        </div>
        <div className="book3d__shadow" />
    </div>
);

export default Book3D;
